import React, { Component } from "react";
import { DKLabel, DKButton } from "deskera-ui-library";
import FunnelManager from "./FunnelManager";
import AppManager from "../../managers/AppManager";
import TemplateSelectionPopup from "./TemplateSelectionPopup";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

class FunnelTypeSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needTemplateSelectionPopup: false,
    };
    this.funnelType = null;
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    FunnelManager.setFunnelDataFromAPI(null);
  }

  render() {
    return (
      <div className=" parent-width align-items-start parent-height">
        <div className="column bg-deskera-secondary p-r border-radius-m border-m mt-r banner-holder">
          <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about funnel and types here.' />

          <div className="row mt-r ml-l">
            <DKButton
              className="border-m bg-white"
              title="Read"
              onClick={AppManager.showComingSoonWarning}
            />
            <DKButton
              className="border-m ml-r bg-white"
              title="Watch"
              onClick={AppManager.showComingSoonWarning}
            />
          </div>
        </div>

        <DKLabel text="Select Funnel type" className="fw-m fs-l mt-xxl" />

        {this.renderAllFunnelTypes()}
        {this.state.needTemplateSelectionPopup &&
          this.getTemplateSelectionPopup()}
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  renderAllFunnelTypes() {
    const types = FunnelManager.getAllFunnelTypes();
    return (
      <div className="row mt-l align-items-start" style={{ gap: 30 }}>
        {types.map((data) => {
          return this.getTypeCard(data);
        })}
      </div>
    );
  }
  getTypeCard(data) {
    return (
      <div
        className="bg-white border-m border-radius-m shadow-s p-l align-items-start column cursor-hand"
        style={{ width: "30%" }}
        onClick={() => {
          this.funnelType = data.type;
          this.showTemplateSelectionPopup();
        }}
      >
        <img src={data.icon} style={{ width: "100%" }} alt="" />
        <DKLabel text={data.title} className="mt-l fw-m fs-l" />
        <DKLabel text={data.description} className="mt-s text-gray" />
        <div className="row-reverse mt-l">
          <DKButton
            title="Select"
            className="bg-app text-white ml-m"
            onClick={() => {}}
          />
          <DKButton
            title="Preview"
            className="bg-gray1 border-m"
            onClick={() => {}}
          />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  getTemplateSelectionPopup() {
    return (
      <TemplateSelectionPopup
        funnelType={this.funnelType}
        onTemplateSelect={(index) => {
          this.templateSelected(index);
        }}
        onCancel={this.hideTemplateSelectionPopup}
      />
    );
  }
  showTemplateSelectionPopup = () => {
    this.setState({ needTemplateSelectionPopup: true });
  };
  hideTemplateSelectionPopup = () => {
    this.setState({ needTemplateSelectionPopup: false });
  };

  templateSelected = (index) => {
    this.hideTemplateSelectionPopup();
    const funnelData = FunnelManager.getNewFunnelData(this.funnelType, index);
    FunnelManager.setCurrentFunnelData(funnelData);
    FunnelManager.setCurrentStepIndex(0);
    RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_BUILDER);
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
}

export default FunnelTypeSelection;
